<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->
      <div v-show="CheckRoute()" class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-edit"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit" ref="searchForm">
            <div class="row">
              <!-- begin: Search input -->
              <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-8">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    id="mbpReqSearch"
                    name="mbpReqSearch"
                    v-model="mbpReqSearch"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจาก ผู้ขอเบิก/ยืม, เลขที่ใบคำร้อง, หมายเหตุกิจกรรม เช่น สมชาย,สมจิตร"
                  />
                </div>
              </div>
              <!-- end: Search input -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย/หน่วยงาน:</label>
                  <select2
                    :class="'form-control m-select2'"
                    :style="'width: 100%;'"
                    :id="'mbpAgent'"
                    :name="'mbpAgent'"
                    :select2-options="mbpAgentOptions"
                    v-model="mbpAgent"
                    ref="mbpAgentSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทใบคำร้อง:</label>
                  <select2
                    :class="'form-control m-select2'"
                    :style="'width: 100%;'"
                    :id="'mbpReqType'"
                    :name="'mbpReqType'"
                    :select2-options="mbpReqTypeOptions"
                    v-model="mbpReqType"
                    ref="mbpReqTypeSelect2"
                  ></select2>
                </div>
              </div>
              <!-- Begin:วันที่เอกสาร input -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">วันที่เอกสาร :</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="วันที่เอกสาร. (วว/ดด/ปปปป)"
                      id="mbpReqDate"
                      name="mbpReqDate"
                      ref="mbpReqDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End:วันที่เอกสาร input -->

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ :</label>
                  <select2
                    :class="'form-control m-select2'"
                    :style="'width: 100%;'"
                    :id="'mbpReqStatus'"
                    :name="'mbpReqStatus'"
                    :select2-options="mbpReqStatusOptions"
                    v-model="mbpReqStatus"
                    ref="mbpReqStatusSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>เปิดใบงาน :</label>
                  <!-- <select2
                    :class="'form-control m-select2'"
                    :style="'width: 100%;'"
                    :id="'mbpOpenJopStatusCodes'"
                    :name="'mbpOpenJopStatusCodes'"
                    :select2-options="mbpOpenJopStatusCodesOptions"
                    v-model="mbpOpenJopStatusCodes"
                    ref="mbpOpenJopStatusCodes"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="mbpOpenJopStatusCodes"
                    :multiple="true"
                    :options="mbpOpenJopStatusCodesOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>หมวดหมู่ :</label>
                  <select2
                    :class="'form-control m-select2'"
                    :style="'width: 100%;'"
                    :id="'mbpProductGroupId'"
                    :name="'mbpProductGroupId'"
                    :select2-options="mbpProductGroupOptions"
                    v-model="mbpProductGroupId"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สินค้า :</label>
                  <!-- <select2
                    :class="'form-control m-select2'"
                    :style="'width: 100%;'"
                    :id="'mbpProductIds'"
                    :name="'mbpProductIds'"
                    :select2-options="mbpProductIdsOptions"
                    v-model="mbpProductIds"
                    ref="mbpProductIds"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="mbpProductIds"
                    :multiple="true"
                    :options="mbpProductIdsOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <router-link
                  to="Borrow/Add"
                  tag="button"
                  title="เพิ่มข้อมูลเบิก/ยืม"
                  class="btn btn-outline-brand"
                  v-if="
                    this.$root.canShow([
                      'MANAGE_MASTER',
                      'JOB_ADMIN_BORROW',
                      'JOB_ADMIN_BORROW_PLANT',
                    ])
                  "
                >
                  <i class="fa fa-plus-circle"></i> เพิ่มข้อมูลเบิก/ยืม
                </router-link>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="table"
              >
                <thead>
                  <tr>
                    <th class="all">วันที่เอกสาร</th>
                    <th class="all">เลขที่ใบคำร้อง</th>
                    <th class="all">ประเภทใบคำร้อง</th>
                    <th class="all">หมวดหมู่</th>
                    <th class="all">มูลค่ารวม</th>
                    <th class="all">ตัวแทนจำหน่าย/หน่วยงาน</th>
                    <th class="all">ผู้ขอเบิก/ยืม</th>
                    <th class="all">หมายเหตุกิจกรรม</th>
                    <th class="all">สถานะ</th>
                    <th class="all">เปิดใบงาน</th>
                    <th class="all">การจัดการ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
import datepicker from "../../Shared/Datepicker";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let Action = Vue.extend({
  template: `
  <div>
  <a href="#" @click.prevent="detail" v-if="data.showDetailButton" title="รายละเอียด" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-search"></i>
    </a>
    <a :href="'/Print/BorrowRetrievePrint/' + data.productLoanHeaderId" target="_blank" v-if="data.showDetailButton" title="ใบจ่ายสินค้า" class="btn btn-sm btn-clean btn-icon btn-icon-md">
        <i class="la la-print" style="color: #800080"></i>
    </a>
    <a href="#" @click.prevent="openJob" v-if="data.showopenJobButton" title="เปิด Job" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="kt-font-priceTier flaticon-file-1 kt-font-success"></i>
    </a>
    <a href="#" @click.prevent="openJobReturn" v-if="data.showopenJobReturnButton" title="เปิด Job รับคืนสินค้า" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="kt-font-priceTier flaticon-interface-4 kt-font-danger"></i>
    </a>
    <a href="#" @click.prevent="openJobCompleted('complete')" v-if="data.showOpenJobCompletedButton" title="ใบงานเสร็จสิ้น" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="fa fa-archive kt-font-primary"></i>
    </a>
    <a href="#" @click.prevent="openJobCompleted('done')" v-if="data.showOpenJobDoneButton" title="เปลี่ยนเปิดใบงานเป็น &quot;ดำเนินการเรียบร้อย&quot;" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-refresh kt-font-success"></i>
    </a>
    <a href="#" @click.prevent="approve" v-if="data.showApproveButton" title="อนุมัติ" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-file-text"></i>
    </a>
    <a href="#" @click.prevent="edit" v-if="data.showEditButton" title="แก้ไข" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-edit"></i>
    </a>
    <a href="#" @click.prevent="print" v-if="data.showprintButton" title="พิมพ์" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="fas fa-print"></i>
    </a>
    <a href="#" @click.prevent="deleteProductLoan" v-if="data.showDeleteButton" title="ยกเลิก" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-trash"></i>
    </a>
    <a href="#" @click.prevent="undo" v-if="data.showUndoButton" title="ถอยสถานะ" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="fas fa-undo-alt"></i>
    </a>
  </div>`,
  methods: {
    edit: function() {
      router.push({
        path: `/Borrow/Edit/${this.data.productLoanHeaderId}`,
      });
    },
    detail: function() {
      router.push({
        path: `/Borrow/Edit/${this.data.productLoanHeaderId}`,
      });
    },
    approve: function() {
      router.push({
        path: `/Borrow/Approve/${this.data.productLoanHeaderId}`,
      });
    },
    openJob: function() {
      router.push({
        path: `/Borrow/OpenJop/${this.data.productLoanHeaderId}`,
      });
    },
    openJobReturn: function() {
      router.push({
        path: `/Borrow/OpenJopReturn/${this.data.productLoanHeaderId}`,
      });
    },
    deleteProductLoan: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งยกเลิกข้อมูลการเบิก/ยืม",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งยกเลิกข้อมูลการเบิก/ยืม <strong>" +
          "</strong> หลังจากยกเลิกแล้วจะส่งผลให้ข้อมูลการเบิก/ยืมนี้ไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ยกเลิกข้อมูลการเบิก/ยืม",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังดำเนินการ กรุณารอสักครู่...",
          });
          axios
            .put(
              "/Api/ProductLoan/" + this.data.productLoanHeaderId + "/Delete"
            )
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
    openJobCompleted: function(type) {
      let self = this;
      let alerttext = "กรุณายืนยันคำสั่งปรับสถานะการเปิดใบงาน <strong>" +
          "</strong> หลังจากปรับสถานะการเปิดใบงานเป็นเสร็จสิ้นแล้วจะส่งผลให้เอกสารนั้นดูได้อย่างเดียว";
      if(type == 'done'){
        alerttext = "</strong> กรุณายืนยันคำสั่งปรับสถานะคอลัมน์เปิดใบงานเป็น \"ดำเนินการเรียบร้อย\"";
      }
      Swal.fire({
        title: "คำสั่งปรับสถานะการเปิดใบงาน",
        type: "warning",
        html: alerttext,
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ปรับสถานะการเปิดใบงาน",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังดำเนินการ กรุณารอสักครู่...",
          });
          axios
            .put(
              "/Api/ProductLoan/" +
                this.data.productLoanHeaderId +
                "/OpenJobCompleted?type=" + type
            )
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

export default {
  components: {
    select2,
    datepicker,
    Treeselect,
  },
  data: function() {
    var self = this;
    return {
      mbpAgent: null,
      mbpReqUser: null,
      mbpReqType: null,
      mbpReqDate: null,
      mbpReqDocNo: null,
      mbpReqStatus: null,
      mbpReqSearch: null,
      mbpOpenJopStatusCodes: [],
      mbpProductGroupId: null,
      mbpProductIds: [],

      mbpAgentOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductLoan/Select2AgentOrg4Search",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      mbpReqTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "PRODUCT_LOAN_REQUEST_TYPE",
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      mbpReqStatusOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "PRODUCT_LOAN_STATUS",
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      mbpOpenJopStatusCodesOptions: [],
      // mbpOpenJopStatusCodesOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options",
      //     data: function(params) {
      //       var query = {
      //         search: "OPEN_JOB_STATUS",
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      mbpProductGroupOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "PRODUCT_LOAN_PRODUCT_GROUP",
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      mbpProductIdsOptions: [],
      // mbpProductIdsOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: false,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       let productGroupId = "";
      //       if (self.mbpProductGroupId != null) {
      //         if (self.mbpProductGroupId == "PRODUCT_LOAN_PRODUCT_GROUP_SPARE")
      //           productGroupId = "1";
      //         else if (
      //           self.mbpProductGroupId == "PRODUCT_LOAN_PRODUCT_GROUP_PREMIUMS"
      //         )
      //           productGroupId = "2";
      //       }

      //       var query = {
      //         search: params.term,
      //         // productTypeId:
      //         //   self.item.plProductType != null ? self.item.plProductType : "",
      //         productGroupId: productGroupId,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  methods: {
    formReset: function(e) {
      let self = this;
      self.mbpReqDate = null;
      self.mbpReqSearch = null;
      self.mbpProductIds = [];

      $("#mbpReqDate")
        .val("")
        .trigger("change");

      $("#mbpAgent")
        .val("")
        .trigger("change");

      $("#mbpReqType")
        .val("")
        .trigger("change");

      $("#mbpReqStatus")
        .val("")
        .trigger("change");

      $("#mbpProductGroupId")
        .val("")
        .trigger("change");

      $("#mbpProductIds")
        .val("")
        .trigger("change");

      //set default OpenJobStatus
      self.mbpOpenJopStatusCodes = [
        "OPEN_JOB_STATUS_WAITING",
        "OPEN_JOB_STATUS_DONE",
      ];

      self.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#table").DataTable();
      table.search(this.id);
      table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#table")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    CheckRoute() {
      var url = this.$route.path;
      if (url == "/Borrow/Edit/" + this.$root.$route.params.id) return false;
      else if (url == "/Borrow/Approve/" + this.$root.$route.params.id)
        return false;
      else if (url == "/Borrow/OpenJopReturn/" + this.$root.$route.params.id)
        return false;
      else if (url == "/Borrow/Add") return false;
      else return true;
    },
    LoadalAreaNewOptions: function(e) {
      var self = this;

      let productGroupId = "";
      if (self.mbpProductGroupId != null) {
        if (self.mbpProductGroupId == "PRODUCT_LOAN_PRODUCT_GROUP_SPARE")
          productGroupId = "1";
        else if (
          self.mbpProductGroupId == "PRODUCT_LOAN_PRODUCT_GROUP_PREMIUMS"
        )
          productGroupId = "2";
      }

      axios
        .get("/Api/Product/Select2Product", {
          params: {
            productGroupId: productGroupId,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.mbpProductIdsOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadmbpOpenJopStatusCodesOptions: function(e) {
      var self = this;

      axios
        .get("/Api/Variables/Options", {
          params: {
            search: "OPEN_JOB_STATUS",
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.mbpOpenJopStatusCodesOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;

    self.LoadalAreaNewOptions();
    self.LoadmbpOpenJopStatusCodesOptions();
    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.mbpReqDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });

    //self.mbpReqDate = moment();
    $(self.$refs.mbpReqDate)
      //.datepicker("update", self.mbpReqDate.format("DD/MM/YYYY"))
      .on("changeDate", function(e) {
        self.mbpReqDate = moment(e.date);
      });

    //set default OpenJobStatus
    self.mbpOpenJopStatusCodes = [
      "OPEN_JOB_STATUS_WAITING",
      "OPEN_JOB_STATUS_DONE",
    ];
    // self.$refs.mbpOpenJopStatusCodes.setSelectedData([
    //   { id: "OPEN_JOB_STATUS_WAITING", text: "รอดำเนินการ" },
    //   { id: "OPEN_JOB_STATUS_DONE", text: "ดำเนินการเรียบร้อย" },
    // ]);
    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#table");

    // begin first table
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/ProductLoan/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            //check for clear date value
            var idDate = $("#mbpReqDate").val();
            if (idDate == null || idDate == "") self.mbpReqDate = null;

            let jsonSearch = {
              AgentId: self.mbpAgent,
              CreatedUser: self.mbpReqUser,
              RequestDocNo: self.mbpReqDocNo,
              RequestDocType: self.mbpReqType,
              RequestDate:
                self.mbpReqDate != null
                  ? self.mbpReqDate.format("DD/MM/YYYY")
                  : self.mbpReqDate,
              ProductLoanStatus: self.mbpReqStatus,
              OpenJopStatusCodes: self.mbpOpenJopStatusCodes,
              ProductIds: self.mbpProductIds,
              SearchKeyword: self.mbpReqSearch,
              ProductGroupId: self.mbpProductGroupId,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },

        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[1, "desc"]],
        select: {
          style: "multi",
          selector: "td:first-child",
        },
        columns: [
          { data: "requestDateFormat", className: "text-center" },
          { data: "requestDocNo", className: "text-center" },
          { data: "requestTypeName", className: "text-center" },
          { data: "productGroupName", className: "text-center" },
          {
            data: "amount",
            render: function(value) {
              return self.$options.filters.currency(value, "฿");
            },
            className: "text-center",
          },
          { data: "agentOrgName", className: "text-center" },
          { data: "requestUser", className: "text-center" },
          { data: "activityRemark", className: "text-center" },
          {
            data: "productLoanStatus",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (
                full.productLoanStatusCode ==
                  "PRODUCT_LOAN_STATUS_INPROGRESS_1" ||
                full.productLoanStatusCode ==
                  "PRODUCT_LOAN_STATUS_INPROGRESS_2" ||
                full.productLoanStatusCode == "PRODUCT_LOAN_STATUS_INPROGRESS_3"
              ) {
                return (
                  '<span class="text-warning">' +
                  full.productLoanStatus +
                  "</span>"
                );
              } else if (
                full.productLoanStatusCode == "PRODUCT_LOAN_STATUS_APPROVED"
              ) {
                return (
                  '<span class="text-success">' +
                  full.productLoanStatus +
                  "</span>"
                );
              } else if (
                full.productLoanStatusCode == "PRODUCT_LOAN_STATUS_REJECT"
              ) {
                return (
                  '<span class="text-danger">' +
                  full.productLoanStatus +
                  "</span>"
                );
              } else {
                return full.productLoanStatus;
              }
            },
          },
          {
            data: "openJobStatusCode",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (full.openJobStatusCode == "OPEN_JOB_STATUS_DONE") {
                return (
                  '<span class="text-success"><i class="fa fa-check-circle"></i>' +
                  full.openJobStatus +
                  "</span>"
                );
              } else if (full.openJobStatusCode == "OPEN_JOB_STATUS_WAITING") {
                return (
                  '<span class="text-dark"><i class="fa fa-circle-notch"></i>' +
                  full.openJobStatus +
                  "</span>"
                );
              } else return full.openJobStatus;
            },
          },
          {
            data: "productLoanHeaderId",
            className: "text-center",
            width: "15%",
            // orderable: true,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditButton =
              self.$root.canShow([
                "MANAGE_MASTER",
                "JOB_ADMIN_BORROW",
                "JOB_ADMIN_BORROW_PLANT",
              ]) && data.productLoanStatus == "PRODUCT_LOAN_STATUS_SAVED";
            data.showDetailButton = self.$root.canShow([
              "MANAGE_MASTER",
              "JOB_ADMIN_BORROW",
              "JOB_ADMIN_BORROW_PLANT",
              "JOB_ADMIN_BORROW_APPROVE",
              "JOB_ADMIN_BORROW_OPENJOB",
            ]);
            data.showopenJobButton =
              data.isShowOpenJop &&
              self.$root.canShow(["MANAGE_MASTER", "JOB_ADMIN_BORROW_OPENJOB"]);
            data.showopenJobReturnButton =
              data.isShowOpenJopReturn &&
              self.$root.canShow(["MANAGE_MASTER", "JOB_ADMIN_BORROW_OPENJOB"]);
            data.showApproveButton =
              data.isApprove &&
              self.$root.canShow(["JOB_ADMIN_BORROW_APPROVE"]);
            // data.showprintButton = self.$root.canShow(['MANAGE_MASTER']);
            data.showDeleteButton =
              data.productLoanStatusCode != "PRODUCT_LOAN_STATUS_APPROVED" &&
              data.productLoanStatusCode != "PRODUCT_LOAN_STATUS_CANCEL" &&
              self.$root.canShow(["MANAGE_MASTER"]);
            //data.showUndoButton = self.$root.canShow(['MANAGE_MASTER']);
            data.showOpenJobCompletedButton =
              data.isShowOpenJopCompleted &&
              self.$root.canShow(["MANAGE_MASTER", "JOB_ADMIN_BORROW_OPENJOB"]);
            data.showOpenJobDoneButton = data.openJobStatusCode == "OPEN_JOB_STATUS_COMPLETED" && self.$root.canShow(["MANAGE_MASTER"]);
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
    // table.trigger("draw.dt"); //call ajax delete this row
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Borrow/ManageBorrowProducts.vue